import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@shared/supabase/client';

/** Lands here from Instagram OAuth. Validates CSRF state, then lets the
 *  ig-oauth-callback edge fn exchange the code and bind creator/brand.
 *  Tokens never touch this page. */
export default function IgCallback() {
  const [msg, setMsg] = useState('Подключаем Instagram…');
  const [done, setDone] = useState<null | { ok: boolean; kind?: string; back: string }>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // OAuth code is single-use — never call twice
    ran.current = true;
    (async () => {
      const q = new URLSearchParams(window.location.search);
      const code = q.get('code');
      const state = q.get('state') ?? '';
      const saved = sessionStorage.getItem('ig_connect_state');
      sessionStorage.removeItem('ig_connect_state');
      const intent = (state.split(':')[0] || '') as 'creator' | 'brand';
      const back = intent === 'brand' ? '/customer/profile' : '/provider';
      if (!code || !saved || saved !== state || !['creator', 'brand'].includes(intent)) {
        setMsg('Некорректный ответ от Instagram. Попробуйте подключить ещё раз.');
        setDone({ ok: false, back });
        return;
      }
      const { data, error } = await supabase.functions.invoke('ig-oauth-callback', {
        body: { code, redirect_uri: `${window.location.origin}/ig-callback`, intent },
      });
      if (error || data?.error) {
        const e = data?.error ?? error?.message ?? 'unknown';
        setMsg(
          e === 'account_claimed_by_another_user' ? 'Этот Instagram уже привязан к другому пользователю.'
          : e === 'brand_owned_by_another_advertiser' ? 'Этот бренд уже принадлежит другой компании.'
          : e === 'no_advertiser' ? 'Сначала привяжите свою компанию (заявка на компанию в профиле).'
          : `Не получилось подключить: ${e}`);
        setDone({ ok: false, back });
        return;
      }
      if (data?.matched) {
        setMsg(intent === 'brand'
          ? `Бренд @${data.handle} подтверждён и привязан к вашей компании.`
          : `Аккаунт @${data.handle} подтверждён и привязан к вашему профилю.`);
      } else {
        setMsg(`@${data?.username}: аккаунт подключён, но пока не найден в каталоге — мы добавим его после проверки.`);
      }
      setDone({ ok: true, kind: intent, back });
    })();
  }, []);

  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 'var(--fs-h2, 20px)', fontWeight: 600, maxWidth: 520 }}>{msg}</div>
      {done && (
        <Link to={done.back} style={{ color: 'var(--accent, #4a9eff)' }}>
          {done.kind === 'brand' ? 'Вернуться в профиль' : 'Вернуться в кабинет'}
        </Link>
      )}
    </div>
  );
}
